import certified from '../../../assets/question.svg';

function QuestionIcon({ color, size }: { color: string; size: number }) {
  return (
    <img src={certified} alt="" color={color} height={size} width={size} />
  );
}

export default QuestionIcon;
